/**
 * Emit hosts for the `compliance` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type NHSTemplateComplianceDetailedProps } from '@/models/analytics/features/compliance';
import { ComplianceSource, ComplianceStatus } from '@heidi/growth/contracts';

export function trackNhsTemplateComplianceBlock(
  props?: NHSTemplateComplianceDetailedProps
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ComplianceCheck,
    props: {
      source: ComplianceSource.NHSTemplate,
      status: ComplianceStatus.Blocked,
      ...props,
    },
  });
}

export function trackNhsTemplateComplianceWarning(
  props?: NHSTemplateComplianceDetailedProps
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ComplianceCheck,
    props: {
      source: ComplianceSource.NHSTemplate,
      status: ComplianceStatus.Warning,
      ...props,
    },
  });
}
